import React from 'react'
import { ObjectSelectButtonProps } from './ObjectSelectButton.types'
import styles from './ObjectSelectButton.module.scss'
import cl from 'classnames'
import { Button, ImageSquare, Text1, Checkbox } from 'components/shared'
import { ChangeMarkPoint } from 'components/shared/ChangeMarkPoint'
import { useTextMaxWidth } from './ObjectSelectButton.utils'

const ObjectSelectButtonComponent = (props: ObjectSelectButtonProps) => {
  const {
    imageSrc,
    label,
    isSelected,
    onClick,
    versionChange,
    isRemovable
  } = props

  const { containerRef, maxWidth } = useTextMaxWidth()

  return (
    <Button
      preset='icon'
      className={cl(styles.objectButton, ((!isRemovable && isSelected) ? styles.noPointerEvents : ''), {
        [styles.selected]: isSelected,
        [styles.redMarked]: versionChange
      })}
      onClick={onClick}
      ref={containerRef}
    >
      <ImageSquare
        width={34}
        src={imageSrc}
        className={styles.picture}
      />
      <Text1
        style={{ margin: '0 20px', maxWidth }}
        overflowEllipsis
        className={cl({
          [styles.redMarked]: versionChange,
          [styles.lineThrough]: versionChange && !isSelected
        })}
      >
        {label}
      </Text1>
      <Checkbox
        isChecked={isSelected}
        className={cl(styles.checkbox, ((!isRemovable && isSelected) ? styles.checkboxMandatory : ''))}
        fillColor={versionChange ? styles.error : undefined}
      />

      {versionChange && (
        <ChangeMarkPoint
          style={{ right: -25 }}
          {...versionChange}
        />
      )}
    </Button>
  )
}

const ObjectSelectButton = ObjectSelectButtonComponent
export { ObjectSelectButton }
